import { useEffect, useRef, useState } from "react";

import { Modal } from "react-bootstrap";
import MainPagetitle from "../../../layouts/MainPagetitle";
import DocsCard from "../BusinessToCustomer/RegisteredUsers/components/DocsCard";
import ChangePasswordModal from "../elements/ChangePasswordModal";
import AadharCard from "./AadharCard";
import AccountInfoCard from "./AccountInfoCard";
import InfoCard from "./InfoCard";
import PanCard from "./PanCard";
import ProfileModal from "./ProfileModal";

const MyProfile = (props) => {
  const changePasswordModalBtnRef = useRef(null);
  const isConnector = props?.$store?.persona === _enum.ROUTE_PERSONAS.connector;
  const [myinfo, setMyinfo] = useState({});
  const [openCanvas, setOpenCanvas] = useState(false);
  const [goSteps, setGoSteps] = useState(0);

  const openModal = () => {
    setOpenCanvas(true);
  };

  const closeModal = () => {
    setOpenCanvas(false);
    getConnectorInfo();
  };

  const onModalClose = () => {
    closeModal();
  };

  const handleSubmit = (e, pandetails) => {
    getConnectorInfo();
    swal2.fire({
      title: "Profile updated successfully",
      icon: "success",
      iconColor: "#234C9B",
      timer: 4000,
    });
  };

  const handleEsignSubmit = () => {
    closeModal();
    props.setstore("esignlink", null);
    props.store("user", {
      ...props?.$store?.user,
      is_agreement_signed: true,
    });
  };

  const onEdit = (e, route) => {
    openModal();
    route === "aadhar"
      ? setGoSteps(1)
      : route === "pan"
      ? setGoSteps(2)
      : route === "accountinfo"
      ? setGoSteps(3)
      : setGoSteps(0);
    getConnectorInfo();
  };

  // -----------------------------------------
  // PROFILE IMAGE MODAL
  const [showImageModal, setShowImageModal] = useState(false);
  const [photoFileId, setPhotoFileId] = useState("");

  const closeImageModal = () => {
    setShowImageModal(false);
  };

  const handleImageUpload = (e, data) => {
    e.preventDefault();
    e.stopPropagation();

    let payload = {
      photoFileId: data.photoFileId,
    };

    props.apis.apiUploadDocs(payload).then((res) => {
      swal2.fire({
        title: "Profile photo updated successfully.",
        icon: "success",
        iconColor: "#234C9B",
        timer: 4000,
      });
      closeImageModal();
      getConnectorInfo();
    });
  };
  const onProfileImageEdit = (e) => {
    setPhotoFileId(myinfo?.photoFileId);
    setShowImageModal(true);
  };
  // -----------------------------------------

  const getAvatar = (fileId) => {
    let authToken = props.$store.auth;
    let url = props.apis.apiGetFileThumnail(
      { auth: authToken },
      { fileId: fileId }
    );
    return url;
  };

  const getConnectorInfo = async () => {
    try {
      const [details, status] = await Promise.all([
        props.apis.apiGetConnectorDetails(),
        props.apis.apiGetConnectorStatus(),
      ]);

      let profileUrl = details?.photoFileId
        ? getAvatar(details.photoFileId)
        : null;

      const combinedInfo = {
        ...details,
        ...(status || {}),
        ...(profileUrl ? { profileUrl } : {}),
      };

      setMyinfo(combinedInfo);

      const isAccValid = Object.values(
        details?.created_by_connector_bank_account_details[0]
      ).every((value) => value !== null && value !== undefined && value !== "");

      let allowedDocsObjs = Object.except(details?.connector_documents[0], [
        "agreement_file_id",
      ]);

      const isDocsValid = Object.values(allowedDocsObjs).every(
        (value) => value !== null && value !== undefined && value !== ""
      );

      console.log({ isDocsValid });

      props.store("user", {
        ...props?.$store?.user,
        isAccountVerified: isAccValid,
        isDocsVerified: isDocsValid,
      });

      // check for profile completion

      let { is_aadhar_verified, is_pan_code_verified, is_agreement_signed } =
        combinedInfo || {};
      if (
        !is_aadhar_verified ||
        !is_pan_code_verified ||
        !is_agreement_signed
      ) {
        swal2
          .fire({
            title: "Please update your profile",
            icon: "info",
            iconColor: "#FF4D4D",
            confirmButtonText: "Update",
            showCancelButton: true,
            cancelButtonText: "Skip for now",
          })
          .then((result) => {
            if (result.isConfirmed) {
              openModal();
            }
          });
      }
    } catch (error) {
      console.error("Failed to fetch connector info:", error);
    }
  };

  // -----------------------------------------------------------------------
  const [changepasswordData, setChangepasswordData] = useState({});
  const [popupChangePasswordFields, setPopupChangePasswordFields] = useState(
    {}
  );
  const [changePasswordFields, setChangePasswordFields] = useState([
    {
      label: "Old Password",
      name: "old_password",
      type: "password",
      customcolspan: "12",
    },
    {
      label: "New Password ",
      name: "new_password",
      type: "password",
      customcolspan: "12",
    },
    {
      label: "Confirm Password",
      name: "confirmPassword",
      type: "password",
      customcolspan: "12",
    },
  ]);

  const addChangepasswordData = () => {
    let fields = (changePasswordFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    setPopupChangePasswordFields(fields);
    setChangepasswordData(formdata);
    openChangePasswordmodal();
  };

  const openChangePasswordmodal = () => {
    changePasswordModalBtnRef.current.click();
  };

  const closeChangePasswordmodal = () => {
    document.querySelector("#changepasswordModal #bsmodalclose").click();
    setChangePasswordFields([]);
    setChangepasswordData({});
  };

  const handleChangePasswordSubmit = (e, data) => {
    if (data.new_password !== data.confirmPassword) {
      swal2.fire({
        title: "Password and Confirm Password does not match",
        icon: "warning",
        iconColor: "#234C9B",
        timer: 4000,
      });
    } else {
      let payload = {
        old_password: data.old_password,
        new_password: data.new_password,
      };

      props.apis.apiConnectorPasswordReset(payload).then((res) => {
        console.log({ res });

        if (res) {
          swal2
            .fire({
              title: "Password changed successfully, Please re-login",
              icon: "success",
              iconColor: "#234C9B",
            })
            .then((result) => {
              if (result.isConfirmed) {
                closeChangePasswordmodal();
                props.store("logged", {});
                props.store("loggedIn", null);
                props.store("auth", null);
                props.store("user", {});
                props.store("persona", _enum.ROUTE_PERSONAS.connector);
                props.navigate("/open/connector/login");
              }
            });
        }
      });
    }
  };

  // -----------------------------------------------------------------------

  useEffect(() => {
    // Always fetch user info
    getConnectorInfo();

    // If password not updated, force change password first
    // if (!is_password_updated) {
    //   addChangepasswordData();
    //   return; // Stop further execution
    // }
  }, []);

  props.$setNode({
    props,
  });

  return (
    <>
      <MainPagetitle
        mainTitle="My Profile"
        pageTitle={"My Profile"}
        parentTitle={"Home"}
        pageIcon={imagepaths.ProfileActive}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card px-2 pt-2">
              <div className="card-body">
                <InfoCard
                  onEdit={(...args) => onEdit(...args)}
                  {...(isConnector
                    ? {
                        showImageEdit: true,
                      }
                    : {})}
                  onProfileImageEdit={(...args) => onProfileImageEdit(...args)}
                  data={myinfo}
                />
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-6 col-xl-4">
                    <AadharCard
                      onEdit={(...args) => onEdit(...args)}
                      aadhardata={myinfo?.connector_aadhar_info}
                    />
                  </div>
                  <div className="col-12 col-md-12 col-lg-6 col-xl-4">
                    <PanCard
                      onEdit={(...args) => onEdit(...args)}
                      pandata={myinfo?.connector_pan_info}
                    />
                  </div>
                  <div className="col-12 col-md-12 col-lg-6 col-xl-4">
                    <AccountInfoCard
                      onEdit={(...args) => onEdit(...args)}
                      accountinfodata={
                        myinfo?.created_by_connector_bank_account_details &&
                        myinfo?.created_by_connector_bank_account_details[0]
                      }
                    />
                  </div>
                </div>
                <div className="">
                  <DocsCard data={myinfo} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* below button hidden on UI */}
      <button
        className="btn btn-sm btn-outline-secondary d-none"
        onClick={(e) => addChangepasswordData(e)}
        ref={changePasswordModalBtnRef}
        data-bs-toggle="modal"
        data-bs-target="#changepasswordModal"
      >
        <span>Change Password</span>
      </button>
      <ChangePasswordModal
        id="changepasswordModal"
        title="Change Password"
        submitText="Change Password"
        modalSize="default"
        hidecancelbtn={true}
        centerchangebtn={true}
        hidecloseicon={false}
        data={changepasswordData}
        fields={popupChangePasswordFields}
        onSubmit={(...args) => handleChangePasswordSubmit(...args)}
        modaltype="centeredmodal"
        onClose={() => closeChangePasswordmodal()}
      />

      <ProfileModal
        id="profileCanvas"
        className="profile_canvas"
        title="Please Verify Below Information"
        show={openCanvas}
        handleSubmit={(...args) => handleSubmit(...args)}
        handleEsignSubmit={(...args) => handleEsignSubmit(...args)}
        onModalClose={(...args) => onModalClose(...args)}
        setGoSteps={setGoSteps}
        goSteps={goSteps}
        onClose={() => onModalClose()}
        myinfo={myinfo}
      />

      {/* PROFILE IMAGE MODAL */}
      <Modal
        show={showImageModal}
        onHide={closeImageModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header
          closeButton
          className="border-0 py-4 d-flex align-item-start"
        >
          <h2>Update Profile Photo</h2>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-3 mb-4">
            <AppForm onSubmit={handleImageUpload}>
              <AppInput
                type="file"
                name="photoFileId"
                foldername="kycDocs"
                accept=".png, .jpg, .jpeg"
                defaultValue={photoFileId}
                fileLabel="Upload Photo"
                label="Photo"
              />
              <div className="col-12 d-flex align-items-center justify-content-center">
                <button
                  type="button"
                  className="formdata-cancel-btn btn px-5 py-2"
                  onClick={(e) => closeImageModal()}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5 py-2 ms-3"
                >
                  Update
                </button>
              </div>
            </AppForm>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(MyProfile);
